import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { GlobalStorage } from 'src/app/apv/core/services/globals.service';
import { BffService } from 'src/app/apv/core/services/http/bff.http.service';
import { toClp } from 'src/app/apv/core/utils/formatters';
import {
  ACTIVE_SUBSCRIPTIONS_CCV,
  ERROR_INVALID_EXEC_RUT,
} from 'src/app/shared/common/constants';

import { Auth } from '@angular/fire/auth';
import { IonicStorageService } from 'src/app/apv/core/services/storage/ionic/storage.service';
import { removeDotsFromText } from 'src/app/apv/core/utils/functions';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  @Output() clickVolverButton = new EventEmitter<boolean>();

  newDiscount: string = '';
  newAmountModal: string = '';
  newAmount: string = '';
  subscriptionDataToModify: any;
  user: any;
  showSpinner: boolean = false;
  isSubscriptionDisabled: boolean = false;
  executiveRut: string = '';
  employerMail: string = '';
  toClp = toClp;
  onFocusEditar: boolean = false;
  onFocusSalir: boolean = false;
  token: string = '';

  constructor(
    private readonly globalSvc: GlobalStorage,
    private readonly bffService: BffService,
    private readonly router: Router,
    private readonly ionicStorage: IonicStorageService,
    private readonly firebaseAuth: Auth,
  ) {}

  ngOnInit(): void {
    this.getDataFromStorage();
    this.getUserDataFromToken();
  }

  ngOnDestroy(): void {
    this.handleVolverButton();
  }

  public isSubscriptionButtonDisabled() {
    return this.isSubscriptionDisabled;
  }

  async submitModifySubscription() {
    this.isSubscriptionDisabled = true;
    this.showSpinner = true;
    try {
      const subscriptionData = sessionStorage.getItem(
        'subscriptionDataToModify'
      );
      if (subscriptionData) {
        const subscriptionDataToModify = JSON.parse(subscriptionData);
        let discountType;
        switch (this.newDiscount) {
          case 'pesos':
            discountType = 'P';
            break;
          case 'uf':
            discountType = 'U';
            break;
          case 'porcentaje':
            discountType = 'R';
            break;
          default:
            discountType = '';
            break;
        }

        const executiveRut = this.executiveRut;

        const executive = {
          rut: removeDotsFromText(
            executiveRut.slice(0, -2)
          ),
          checkDigit: String(executiveRut.slice(-1)),
        };

        const subscriptionDataNew = {
          name: this.user.name,
          email: this.user.email,
          fundTypeDestination: subscriptionDataToModify.fundTypeDestination,
          taxRegimeCode: subscriptionDataToModify.taxRegimeCode,
          discountValue: +this.newAmount,
          discountType: discountType,
          requestNumber: +subscriptionDataToModify.requestNumber,
          DocumentNumber: +subscriptionDataToModify.DocumentNumber,
          oldDiscountValue: +subscriptionDataToModify.discountValue,
          oldDiscountType: subscriptionDataToModify.discountType,
          employer: {
            rut: +subscriptionDataToModify.employerRut.slice(0, -1),
            checkDigit: String(subscriptionDataToModify.employerRut.slice(-1)),
            name: subscriptionDataToModify.employerName,
            email: this.employerMail,
            address: await this.checkAndGetEmployerAddress(
              subscriptionDataToModify.employerAddress,
              subscriptionDataToModify.employerRut.slice(0, -1) + String(subscriptionDataToModify.employerRut.slice(-1))
            ),
          },
          executive,
        };
        const response = await this.bffService.modifySubscription(
          subscriptionDataNew,
          this.token
        );

        console.log('[SubmitModifySuscription]' + '[Success] ', response);
        const finalAmount = {
          ...subscriptionDataNew,
          folio: response.data.data.status.status.Modificacion[0].folio,
          pdf: response.data.data.status.status.pdf,
        };

        sessionStorage.setItem('finalAmount', JSON.stringify(finalAmount));
        sessionStorage.removeItem('newAmountCcv');
        sessionStorage.removeItem('newDiscountCcv');
        await this.ionicStorage.remove(ACTIVE_SUBSCRIPTIONS_CCV);
        this.globalSvc.activeSubscriptions = [];

        this.cleanStorageData();
        this.router.navigate(['/home/ccv/successful-modifcation']);
      }
    } catch (error: any) {
      this.showSpinner = false;
      const errorCode: any = error.response.data.data.error.error.code;

      console.log('[SubmitModifySuscription]' + '[Error] ', error);

      if (errorCode.toString() !== ERROR_INVALID_EXEC_RUT) {
        sessionStorage.setItem('errorSubscriptionCode', errorCode);
        this.cleanStorageData();
        this.router.navigate(['/home/ccv/failed-subscription']);
      }
    }
  }

  private cleanStorageData(): void {
    sessionStorage.removeItem('newAmountCcv');
    sessionStorage.removeItem('newDiscountCcv');
    sessionStorage.removeItem('newRutCcv');
    sessionStorage.removeItem('newEmailCcv');
  }

  private readonly getUserDataFromToken = async () => {
    try {
      this.token =  String(await (
        await this.firebaseAuth.currentUser
      )?.getIdToken());

      this.globalSvc.token = this.token;

      const decodedToken: any = jwt_decode(this.token);

      this.user = {
        name: decodedToken.name,
        lastName: decodedToken.lastName,
        rut: decodedToken.user_id,
        email: decodedToken.email,
      };
    } catch (error) {
      console.error('Error getting user data from token');
      console.log(error);
    }
  };

  getDataFromStorage() {
    const subscriptionDataNew = sessionStorage.getItem('newAmountCcv');
    if (subscriptionDataNew) {
      this.newAmount = subscriptionDataNew.replaceAll('.', '');
    }
    const subscriptionDataModal = sessionStorage.getItem('newDiscountCcv');
    if (subscriptionDataModal) {
      this.newAmountModal = subscriptionDataModal.replaceAll('.', '');
    }
    const subscriptionDataDiscount = sessionStorage.getItem('newDiscountCcv');
    if (subscriptionDataDiscount) {
      this.newDiscount = subscriptionDataDiscount;
    }
    const subscriptionData = sessionStorage.getItem('subscriptionDataToModify');
    if (subscriptionData) {
      this.subscriptionDataToModify = JSON.parse(subscriptionData);
    }
    const subscriptionDataRutExecutive = sessionStorage.getItem('newRutCcv');
    if (subscriptionDataRutExecutive) {
      this.executiveRut = subscriptionDataRutExecutive;
    }
    const subscriptionDataEmail = sessionStorage.getItem('newEmailCcv');
    if (subscriptionDataEmail) {
      this.employerMail = subscriptionDataEmail;
    }
  }

  savesOldAmount() {
    return this.currencyByAmountAndCurrencyCode(
      this.subscriptionDataToModify.discountValue,
      this.subscriptionDataToModify.discountType
    );
  }

  savesNewAmount() {
    return this.currencyByAmountAndCurrency(
      this.newAmount,
      this.newAmountModal
    );
  }

  currencyByAmountAndCurrencyCode(amount: string, currencyCode: string) {
    switch (currencyCode) {
      case 'P':
        return `$${toClp(+amount)}`;
      case 'U':
        return `${toClp(+amount)} UF`;
      case 'R':
        return `${Math.trunc(+amount)}%`;
      default:
        return '';
    }
  }

  currencyByAmountAndCurrency(amount: string, currencyCode: string) {
    switch (currencyCode) {
      case 'pesos':
        return `$${toClp(+amount)}`;
      case 'uf':
        return `${toClp(+amount)} UF`;
      case 'porcentaje':
        return `${Math.trunc(+amount)}%`;
      default:
        return '';
    }
  }

  classBySubscriptionStatus() {
    return this.isSubscriptionDisabled
      ? 'button-disable'
      : 'continue-subscription-button';
  }

  //ver como se informara que tiene que actualizar direccion si no la hay
  private async checkAndGetEmployerAddress(
    address: string | undefined,
    employerRut: string
  ): Promise<string> {
    try {
      if (address) {
        return address;
      }

      const employerDataRes = await this.bffService.getEmployerData(
        employerRut
      );

      const { employerAddress } = employerDataRes.data?.data?.result || {};

      if (!employerAddress) {
        return '';
      }

      return employerAddress;
    } catch (error: any) {
      console.error('Error al procesar el dato:', error); 
      return ''; 
    }
  }

  public handleVolverButton() {
    this.clickVolverButton.emit(true);
  }

  salir() {
    this.handleVolverButton();
    this.limpiarCampos();
    this.router.navigate(['/home/ccv/detail']);
  }

  limpiarCampos() {
    sessionStorage.removeItem('newAmountCcv');
    sessionStorage.removeItem('newDiscountCcv');
    sessionStorage.removeItem('newRutCcv');
    sessionStorage.removeItem('newEmailCcv');
    sessionStorage.removeItem('subscriptionDataToModify');
  }
  setFocusButtonEditar() {
    this.onFocusEditar = !this.onFocusEditar;
  }
  setFocusButtonSalir() {
    this.onFocusSalir = !this.onFocusSalir;
  }
}
